module.exports = __webpack_public_path__ + "img/iconfinder-icon.65fd4ae0.svg";